module.exports = __webpack_public_path__ + "img/bank.aa47b5b4.svg";